import React from 'react';



interface UserContextInterface {
  currentUser?: any;
  setCurrentUser?: any;
  logout?: any;
  hasPermission?: any;
  translations: any;
  environments: any[];
}



const UserContext = React.createContext<UserContextInterface>({
  currentUser: null,
  setCurrentUser: null,
  logout: null,
  hasPermission: null,
  translations: {},
  environments: []
});



export default UserContext;
